import { lazy, useEffect } from "react";
import { Hero } from "@/components/home/Hero";
import { ServicesTeaser } from "@/components/home/ServicesTeaser";
import { NextSessionStrip } from "@/components/home/UpcomingEvents";
import { LazySection, SECTIONS_READY } from "@/components/site/LazySection";
import { HERO_PUBLIC } from "@/data/content";

const LOADERS = {
  AdvisorExplorer: () => import("@/components/home/AdvisorExplorer"),
  EventReelsTeaser: () => import("@/components/home/EventHighlights"),
  Press: () => import("@/components/home/Press"),
  Insights: () => import("@/components/home/Insights"),
  GuidesTeaser: () => import("@/components/home/GuidesTeaser"),
  AboutTeaser: () => import("@/components/home/AboutTeaser"),
  SplitCTA: () => import("@/components/home/SplitCTA"),
};
const pick = (name) => lazy(() => LOADERS[name]().then((m) => ({ default: m[name] })));
const AdvisorExplorer = pick("AdvisorExplorer");
const EventReelsTeaser = pick("EventReelsTeaser");
const Press = pick("Press");
const Insights = pick("Insights");
const GuidesTeaser = pick("GuidesTeaser");
const AboutTeaser = pick("AboutTeaser");
const SplitCTA = pick("SplitCTA");

// Warm every below-the-fold chunk once the browser is idle so scrolling never waits on the network.
const usePrefetchSections = () => useEffect(() => {
  const run = () => Promise.all(Object.values(LOADERS).map((l) => l())).then(() => window.dispatchEvent(new Event(SECTIONS_READY))).catch(() => {});
  if ("requestIdleCallback" in window) { const id = window.requestIdleCallback(run, { timeout: 2500 }); return () => window.cancelIdleCallback(id); }
  const t = setTimeout(run, 1200); return () => clearTimeout(t);
}, []);

export default function Home() {
  usePrefetchSections();
  return (
    <main data-testid="home-page">
      <Hero copy={HERO_PUBLIC} />
      <ServicesTeaser />
      <LazySection minHeight={900} tone="dark" testId="team-teaser"><AdvisorExplorer /></LazySection>
      <NextSessionStrip />
      <LazySection minHeight={700} tone="cream" testId="event-reels-teaser"><EventReelsTeaser /></LazySection>
      <LazySection minHeight={700} tone="sand" testId="press-section"><Press /></LazySection>
      <LazySection minHeight={900} tone="dark" testId="insights-section"><Insights /></LazySection>
      <LazySection minHeight={700} tone="cream" testId="guides-teaser"><GuidesTeaser /></LazySection>
      <LazySection minHeight={800} tone="dark" testId="about-teaser"><AboutTeaser /></LazySection>
      <LazySection minHeight={600} tone="sand" testId="split-cta"><SplitCTA /></LazySection>
    </main>
  );
}
